import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { sendEmailVerification } from 'firebase/auth';

const V2SignupMessage = ({ signUpStateMessage }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { message: textMessage, user } = signUpStateMessage;

    const buttonCommonSx = {
        mt: 2,
        backgroundColor: '#000000',
        color: '#ffffff',
        height: 44,
        borderRadius: '12px',
        textTransform: 'none',
        fontFamily: '"Inter", sans-serif',
        fontWeight: 500,
        fontSize: '15px',
        boxShadow: theme.shadows[1],
        '&:hover': {
            backgroundColor: '#111111',
            boxShadow: theme.shadows[2],
        },
    };

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 420,
                mx: 'auto',
                px: { xs: 3, sm: 0 },
                py: { xs: 4, sm: 0 },
            }}
        >
            {/* Heading */}
            <Typography
                sx={{
                    fontFamily: '"Hedvig Letters Serif", serif',
                    fontSize: isMobile ? '22px' : '24px',
                    lineHeight: isMobile ? '28px' : '30px',
                    letterSpacing: '-0.6px',
                    fontWeight: 500,
                    mb: 1,
                    color: 'black',
                }}
            >
                Heads up
            </Typography>

            {/* Message body */}
            <Typography
                sx={{
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 500,
                    fontSize: isMobile ? '14px' : '15px',
                    lineHeight: '22px',
                    letterSpacing: '-0.2px',
                    opacity: 0.8,
                    color: 'black',
                }}
            >
                {textMessage}
            </Typography>

            {user && (
                <Button
                    variant="contained"
                    fullWidth
                    sx={buttonCommonSx}
                    onClick={() => sendEmailVerification(user)}
                >
                    Resend verification email
                </Button>
            )}
        </Box>
    );
};

export default V2SignupMessage;